'use strict';
var angular = require('angular');

var dashboardWebhooksCtrl = ['$http', '$stateParams', 'dialog', 'Webhook', '$translate', function($http, $stateParams, dialog, Webhook,$translate) {
    var _this = this;

    this.removeWebhook = function(webhook) {
        dialog.confirm({
            title: $translate.instant("DASHBOARD.DASH_WEBHOOKS.DIAG_REMOVE.TITLE"),
            body: $translate.instant("DASHBOARD.DASH_WEBHOOKS.DIAG_REMOVE.BODY"),
            accept: $translate.instant("DASHBOARD.ACCEPT"),
            cancel: $translate.instant("DASHBOARD.CANCEL"),
            size: 'sm'
        }).then(function() {
            Webhook.removeById({
                    id: webhook.id,
                })
                .$promise
                .then(function() {
                    _this.webhooks = _this.webhooks.filter(function(currentWebhook) {
                        return webhook.id !== currentWebhook.id;
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        });
    };
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            webhooks: '='
        },
        controller: dashboardWebhooksCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-webhooks/dashboardWebhooksDirective.html'
    };
};
